<template>
  <nav>
    <div class="warp-top-navbar flex items-center sm:h-30 lg:h-[195px]">
      <div class="container mx-auto py-4">
        <div class="top-nav flex items-center">
          <LogoSimakad class="flex-shrink-0 ml-3 sm:ml-0 md:ml-0 lg:ml-0" />
          <UnivHead />
          <SpmiA />
        </div>
      </div>
    </div>
    <div class="warp-bottom-navbar border-t-4 border-[#02735F] py-2">
      <div class="container mx-auto">
        <!-- Desktop Navbar -->
        <div class="hidden md:flex items-center h-[50px] justify-between">
          <div
            v-for="item in mainMenu"
            :key="item.idmenu"
            class="relative group max-w-[15%] text-center"
          >
            <router-link
              :to="item.link"
              class="text-white text-lg font-medium mx-4 hover:underline "
            >
              {{ item.nama_menu }}
            </router-link>
            <div
              v-if="subMenu[item.idmenu]"
              class="absolute text-left left-0 top-full bg-[#014a3d] hidden group-hover:block"
            >
              <!-- <router-link v-for="subItem in subMenu[item.idmenu]" :key="subItem.idmenu" :to="subItem.link" class="block text-white text-lg font-medium px-6 py-3 hover:bg-[#02735F]">
                {{ subItem.nama_menu }}
              </router-link> -->
              <template
                v-for="subItem in subMenu[item.idmenu]"
                :key="subItem.idmenu"
              >
                <a
                  v-if="subItem.external_link"
                  href="#"
                  @click.prevent="openExternalLink(subItem.external_link)"
                  class="block text-white text-lg font-medium px-6 py-3 hover:bg-[#02735F]"
                >
                  {{ subItem.nama_menu }}
                </a>
                <router-link
                  v-else
                  :to="subItem.link"
                  class="block text-white text-lg font-medium px-6 py-3 hover:bg-[#02735F]"
                >
                  {{ subItem.nama_menu }}
                </router-link>
              </template>
            </div>
          </div>
          <div class="right-menus">
            <div class="btn">
              <a
                href="http://103.135.49.0:8000/newstikes/login"
                
                rel="noopener"
                class="text-white text-lg font-medium px-4 py-2 border border-white rounded bg-[#014a3d] hover:bg-[#014a3d] hover:border-yellow-400 hover:text-yellow-400 transition-colors"
              >
                Login
              </a>
            </div>
          </div>
        </div>
        <!-- Mobile Navbar -->
        <div class="flex md:hidden items-center h-[50px] justify-between px-4">
          <div class="btn">
              <a
                href="http://103.135.49.0:8000/newstikes/"
                target="_blank"
                rel="noopener"
                class="text-white text-l font-medium px-2 py-1 border border-white rounded bg-[#014a3d] hover:bg-[#014a3d] hover:border-yellow-400 hover:text-yellow-400 transition-colors"
              >
                Login
              </a>
            </div>
          <button
            @click="showMenu = !showMenu"
            class="text-white focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
        <!-- Dropdown Mobile Menu -->
        <transition name="slide-fade">
          <div
            v-if="showMenu"
            class="md:hidden absolute left-0 right-0 bg-[#014a3d] z-50 shadow-lg"
          >
            <div v-for="item in mainMenu" :key="item.idmenu" class="relative">
              <button
                @click="toggleSubMenu(item.idmenu, item.link)"
                :class="{ 'bg-[#02735F]': activeSubMenu === item.idmenu }"
                class="block text-white text-lg font-medium px-6 py-3 hover:bg-[#02735F] w-full text-left focus:outline-none"
              >
                {{ item.nama_menu }}
              </button>
              <transition name="slide-fade">
                <div
                  v-if="activeSubMenu === item.idmenu"
                  class="bg-[#014a3d] border-b border-b-[#02735F] w-[95%] mx-auto my-2"
                >
                  <!-- <router-link v-for="subItem in subMenu[item.idmenu]" :key="subItem.idmenu" :to="subItem.link" @click="setActiveSubItem(subItem.idmenu)" :class="{'bg-[#02735F]': activeSubItem === subItem.idmenu}" class="block text-white my-1 text-lg text-left font-medium px-6 py-3 hover:bg-[#02735F] rounded-[15px]"> -->
                  <!-- <router-link v-for="subItem in subMenu[item.idmenu]" :key="subItem.idmenu" :to="subItem.external_link ? undefined : subItem.link" @click="subItem.external_link ? openExternalLink(subItem.external_link) : setActiveSubItem(subItem.idmenu)" :class="{'bg-[#02735F]': activeSubItem === subItem.idmenu}" class="block text-white my-1 text-lg text-left font-medium px-6 py-3 hover:bg-[#02735F] rounded-[15px]">
                    {{ subItem.nama_menu }}
                  </router-link> -->

                  <template
                    v-for="subItem in subMenu[item.idmenu]"
                    :key="subItem.idmenu"
                  >
                    <a
                      v-if="subItem.external_link"
                      href="#"
                      @click.prevent="openExternalLink(subItem.external_link); setActiveSubItem(subItem.idmenu)"
                      :class="{ 'bg-[#02735F]': activeSubItem === subItem.idmenu }"
                      class="block text-white my-1 text-lg text-left font-medium px-6 py-3 hover:bg-[#02735F] rounded-[15px]"
                    >
                      {{ subItem.nama_menu }}
                    </a>
                    <router-link
                      v-else
                      :to="subItem.link"
                      @click="setActiveSubItem(subItem.idmenu)"
                      :class="{
                        'bg-[#02735F]': activeSubItem === subItem.idmenu,
                      }"
                      class="block text-white my-1 text-lg text-left font-medium px-6 py-3 hover:bg-[#02735F] rounded-[15px]"
                    >
                      {{ subItem.nama_menu }}
                    </router-link>
                  </template>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </nav>
  <router-view />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useNavbarSpmiStore } from "@/store/navbarSpmi";
import LogoSimakad from "../LogoSimakad.vue";
import UnivHead from "../navbar/UnivHead.vue";
import SpmiA from "../navbar/SpmiA.vue";

const showMenu = ref(false);
const activeSubMenu = ref(null);
const activeSubItem = ref(null);
const router = useRouter();
const navbarSpmiStore = useNavbarSpmiStore();

onMounted(() => {
  navbarSpmiStore.fetchNavItems();
});

const staticNavItems = computed(() => navbarSpmiStore.staticNavItems);

const mainMenu = computed(() => {
  // Filter hanya menu level 2 (is_main === '0')
  return staticNavItems.value.filter((item) => item.is_main === "26");
});

const subMenu = computed(() => {
  const mapping = {};
  staticNavItems.value.forEach((item) => {
    // Pastikan hanya menu level 3 yang memiliki parent di mainMenu
    if (
      item.is_main !== "26" &&
      mainMenu.value.some((main) => main.idmenu === item.is_main)
    ) {
      if (!mapping[item.is_main]) {
        mapping[item.is_main] = [];
      }
      mapping[item.is_main].push(item);
    }
  });
  return mapping;
});

// Validasi tambahan untuk memastikan data diperiksa satu per satu
console.log("Main Menu:", mainMenu.value);
console.log("Sub Menu:", subMenu.value);

const toggleSubMenu = (idmenu, link) => {
  if (!subMenu.value[idmenu]) {
    activeSubMenu.value = null;
    if (link) {
      showMenu.value = false; // Close the menu
      router.push(link);
    }
  } else {
    activeSubMenu.value = activeSubMenu.value === idmenu ? null : idmenu;
    if (activeSubMenu.value === null) {
      showMenu.value = false; // Close the menu if the submenu is deactivated
    }
  }
};

const openExternalLink = (url) => {
  window.open(
    url,
    "_blank",
    "width=1200,height=600,scrollbars=yes,resizable=yes"
  );
};

// Update setActiveSubItem to handle active state and close the navbar
const setActiveSubItem = (idmenu) => {
  activeSubItem.value = idmenu; // Set the clicked submenu as active
  showMenu.value = false; // Close the mobile navbar
};

const handleClickOutside = (event) => {
  const menuElement = document.querySelector(".warp-bottom-navbar");
  if (menuElement && !menuElement.contains(event.target)) {
    showMenu.value = false;
  }
};

document.addEventListener("click", handleClickOutside);

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style scoped lang="scss">
.warp-top-navbar {
  width: 100%;
  flex-shrink: 0;
  background: linear-gradient(91deg, #014a3d 20.41%, #02735f 99.51%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .univ-name,
  .spmi-title {
    font-family: "Playfair Display", serif;
  }
}

.warp-bottom-navbar {
  width: 100%;
  min-height: 50px;
  background-color: #014a3d;
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
